module.exports = __webpack_public_path__ + "media/images/icons/filled/linkedin-eb73f8f41631f0d91fd6bfc94ecff337.svg";